module.exports = __webpack_public_path__ + "img/csen_big.db423a0c.gif";